module.exports = __webpack_public_path__ + "img/San Francisco.26448438.jpeg";